import { IconCheck } from '../atoms/Icon';
import RichText from '../atoms/RichText';

/** Lista de itens com marca de conferido. A cor da marca vem do contexto (verde
 *  no claro, âmbar sobre o roxo), resolvida no CSS — o componente não escolhe. */
function CheckList({ items, className = '' }) {
  return (
    <ul className={`check-list ${className}`}>
      {items.map((item) => (
        <li key={item}>
          <IconCheck size={17} />
          <span><RichText>{item}</RichText></span>
        </li>
      ))}
    </ul>
  );
}

export default CheckList;
